import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { TextField, Button, Grid, Card, CardMedia, Select, FormControl, InputLabel, MenuItem as SelectMenuItem } from '@mui/material';
import emailjs from "@emailjs/browser";
import Footer from '../Materials/Footer'; 

export default function ContactUsPage() {

  const [formData, setFormData] = useState({
    from_name: "",
    from_email: "",
    message: "",
    request_type: "",
  });

  const [isSending, setIsSending] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const sendEmail = (e) => {
    e.preventDefault();
    setIsSending(true);

    const templateParams = {
      ...formData,
      subject: `Contact Form Submission - ${formData.request_type}`,
    };

    emailjs
      .send(
        "service_qqvjj4m", // ID do serviço no EmailJS
        "template_t8as99r",  // ID do template no EmailJS
        templateParams,
        "LvzARe3Qsdh_JTfsk" // O User ID do EmailJS
      )
      .then(
        () => {
          alert("Mensagem enviada com sucesso! ✅");
          setFormData({ from_name: "", from_email: "", message: "", request_type: "" });
        },
        (error) => {
          alert("Erro ao enviar mensagem! ❌ " + error.text);
        }
      )
      .finally(() => setIsSending(false));
  };

  return (
    <Box sx={{ flexGrow: 1 }}>

      {/* Main Content */}
      <Box sx={{ p: 3, maxWidth: '80%', margin: '0 auto' }}>
        {/* Title */}
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography variant="h4" sx={{ mb: 1 }}>
            Contact Us
          </Typography>
          <Typography variant="body1" sx={{ color: 'gray' }}>
            Get in touch with us for any questions or concerns
          </Typography>
        </Box>

        {/* Contacts and Form */}
        <Grid container spacing={4} alignItems="flex-start">
          {/* Contacts */}
          <Grid item xs={12} md={6}>
            <Box sx={{ backgroundColor: '#f7f7f7', p: 2, borderRadius: 2 }}>
              <Typography variant="h6" sx={{ mb: 1 }}>
                📄 Content Support
              </Typography>
              <Card sx={{ display: 'flex', alignItems: 'center', minWidth: 360, p: 2, mb: 3 }}>
                <Box
                  sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                  }}
                >
                  <CardMedia
                    component="img"
                    sx={{ width: 80, height: 80, borderRadius: '50%', mb: 1 }}
                    image="/andre.png"
                    alt="André Mota"
                  />
                  <Typography variant="h6">André Mota</Typography>
                </Box>
                <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />
                <Box
                  sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                  }}
                >
                  <CardMedia
                    component="img"
                    sx={{ width: 80, height: 80, borderRadius: '50%', mb: 1 }}
                    image="/piedade.png"
                    alt="Piedade Malheiro"
                  />
                  <Typography variant="h6">Piedade Malheiro</Typography>
                </Box>
              </Card>
            </Box>

            <Box sx={{ backgroundColor: '#f7f7f7', p: 2, borderRadius: 2, mt: 2 }}>
              <Typography variant="h6" sx={{ mb: 1 }}>
              🔧 Technical Support
              </Typography>
              <Card sx={{ display: 'flex', alignItems: 'center', minWidth: 360, p: 2 }}>
                <Box
                  sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                  }}
                >
                  <CardMedia
                    component="img"
                    sx={{ width: 80, height: 80, borderRadius: '50%', mb: 1 }}
                    image="/it.png"
                    alt="IT Department"
                  />
                  <Typography variant="h6">IT Department</Typography>
                </Box>
              </Card>
            </Box>
          </Grid>

          {/* Form */}
          <Grid item xs={12} md={6}>
            <Box sx={{ p: 3, maxWidth: "80%", margin: "0 auto", mt: -3 }}>
              {/* Formulário de Contato */}
              <Box
                sx={{
                  backgroundColor: "#f7f7f7",
                  p: 3,
                  borderRadius: 2,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography variant="h6" sx={{ mb: 2, textAlign: "center" }}>
                  Send Us a Message 📩
                </Typography>
                <form onSubmit={sendEmail} style={{ width: "100%" }}>
                  <TextField
                    label="Your Name"
                    name="from_name"
                    variant="outlined"
                    fullWidth
                    sx={{ mb: 2 }}
                    value={formData.from_name}
                    onChange={handleChange}
                    required
                  />
                  <TextField
                    label="Your Email"
                    name="from_email"
                    type="email"
                    variant="outlined"
                    fullWidth
                    sx={{ mb: 2 }}
                    value={formData.from_email}
                    onChange={handleChange}
                    required
                  />
                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>Request Type</InputLabel>
                    <Select
                      label="Request Type"
                      name="request_type"
                      value={formData.request_type}
                      onChange={handleChange}
                      required
                    >
                      <SelectMenuItem value="Hub4Food Issue">Hub4Food Issue</SelectMenuItem>
                      <SelectMenuItem value="Ideation Platform Issue">Ideation Platform Issue</SelectMenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    label="Message"
                    name="message"
                    variant="outlined"
                    fullWidth
                    multiline
                    rows={4}
                    sx={{ mb: 2 }}
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                  <Button type="submit" variant="contained" color="primary" fullWidth disabled={isSending}>
                    {isSending ? "Sending..." : "Send Message"}
                  </Button>
                </form>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>

    
      <Footer /> 
    </Box>
  );
}